import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Title from '../Title/Title';
import { fetchPublishedNews } from '../../lib/newsPostsApi';
import { getNewsExcerpt } from '../../lib/newsUtils';
import { usePageBackground } from '../../lib/cmsUtils';
import defaultHero from '../../assets/main.svg';

import './News.scss';
import './Admin.scss';

const News = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const bgImage = usePageBackground('news', defaultHero);

    const loadNews = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const data = await fetchPublishedNews();
            setNews(data);
        } catch (err) {
            setError(err.message || 'Failed to load news');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadNews();
    }, [loadNews]);

    return (
        <div className="news">
            <Navbar/>
            <header className="news__hero" style={{ backgroundImage: `url(${bgImage})` }}>
                <h1>News</h1>
            </header>
            <main className="newsContainer">
                <Title title="Latest News"/>

                {loading && <p className="newsStatus">Loading...</p>}
                {error && <p className="newsStatus newsStatus--error">{error}</p>}
                {!loading && !error && news.length === 0 && (
                    <p className="newsStatus">No news available.</p>
                )}

                <div className="newsList">
                    {news.map((item) => (
                        <article key={item.id} className="newsItem">
                            {item.cover_image_url && (
                                <div className="newsItem__media">
                                    <img src={item.cover_image_url} alt={item.title} loading="lazy" />
                                </div>
                            )}

                            <div className="newsItem__body">
                                <header className="newsItem__header">
                                    <h2>{item.title}</h2>
                                    <time className="newsItem__date" dateTime={item.date}>
                                        {new Date(item.date).toLocaleDateString()}
                                    </time>
                                </header>

                                <p className="newsItem__excerpt">{getNewsExcerpt(item.body)}</p>

                                <footer className="newsItem__footer">
                                    <Link className="newsItem__readMore" to={`/news/${item.id}`}>
                                        Read more
                                    </Link>
                                </footer>
                            </div>
                        </article>
                    ))}
                </div>

                <Footer/>
            </main>
        </div>
    );
};

export default News;
